import React, { useEffect, useState } from "react";

import { AutoComplete, Input, Avatar, Typography, Tag, Tooltip } from "antd";
import {
  EnvironmentOutlined
} from "@ant-design/icons";

import { getMetricUsers } from "./../../services";
const { Title } = Typography;
const ColorList = ["#f56a00", "#7265e6", "#ffbf00", "#00a2ae"];

const randomIntFromInterval = (min, max) => {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
};

const renderItem = (element, count) => ({
  value: element.email,
  element: element,
  label: (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <>
        {" "}
        <Avatar.Group>
          <Avatar
            className="shape-avatar"
            shape="square"
            size={40}
            style={{
              backgroundColor: ColorList[randomIntFromInterval(0, 3)],
              verticalAlign: "middle",
            }}
          >
            {element.name
              ? element.name.split(" ").length > 1
                ? element.name.split(" ")[0][0] + element.name.split(" ")[1][0]
                : element.name[0]
              : element.name}
          </Avatar>
          <div className="avatar-info">
            <Title level={5}>{element.name}</Title>
            <p>{element.email}</p>
          </div>
        </Avatar.Group>{" "}
        <span className="pdAcPoup">
          <Tooltip title="Runs">
            <Tag color="geekblue">
              <EnvironmentOutlined /> {element.runs}
            </Tag>
          </Tooltip>
        </span>
      </>
    </div>
  ),
});

// const options = [
//   {
//     label: renderTitle('Libraries'),
//     options: [renderItem('AntDesign', 10000), renderItem('AntDesign UI', 10600)],
//   }
// ];

const onSelect = (value) => {
  // console.log("onSelect", value);
};

const PdAutoComplete = (props) => {
  const [data, setData] = useState([]);

  const [filterData, SearchfilterData] = useState(data);

  useEffect(async () => {
    const { data } = await getMetricUsers();
    const thisuArr = data;
    setData(thisuArr);
  }, []);

  const mapAutoComplete = (data) => {
    let thisData = [];

    data.map((item, index) => {
      thisData.push(renderItem(item, 10000));
    });

    return thisData;
  };

  const thisSearch = (value) => {
    // console.log("thisSearch", value);

    let filteredData = [];
    let filteredUsers = [];

    filteredUsers = data.filter((user) => user.name.includes(value) || user.email.includes(value));

    SearchfilterData(mapAutoComplete(filteredUsers));
  };

  return (
    <div>
    <h2>User Search </h2>
    <AutoComplete
      popupClassName="certain-category-search-dropdown"
      dropdownMatchSelectWidth={500}
      style={{
        width: "100%",
      }}
      options={filterData}
      onSelect={props.acSelect}
      onChange={props.acSelect}
      onSearch={thisSearch}
    >
      <Input.Search placeholder="Search PD User " enterButton />
    </AutoComplete>
    </div>
  );
};

export default PdAutoComplete;
